    (function() {
      if (window.__cartSideSuggestionsBound) 
        return







      window.__cartSideSuggestionsBound = true

      function soldOutLabel() {
        var el = document.querySelector('.cart-suggestions')
        return (el && el.dataset.soldOutLabel) || 'Sold out'
      }

      var root = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/'
      var splideInstance = null

      function maybeLoadMore(splide, el) {
        if (el.dataset.suggestionsHasNext !== 'true') 
          return







        if (el.dataset.suggestionsLoading === 'true') 
          return







        var perPage = (splide.options && splide.options.perPage) || 1

// Trigger when the second-to-last existing slide is visible
// (visible range = [index, index + perPage - 1]).
        if (splide.index + perPage - 1 < splide.length - 2) 
          return







        loadNextPage(splide, el)
      }

      async function loadNextPage(splide, el) {
        el.dataset.suggestionsLoading = 'true'
        try {
          var handle = el.dataset.suggestionsHandle
          var nextPage = parseInt(el.dataset.suggestionsPage || '1', 10) + 1
          var url = root + 'collections/' + handle + '?view=cart-suggestions&page=' + nextPage
          var res = await fetch(url, {credentials: 'same-origin'})
          if (! res.ok) 
            throw new Error('fetch failed: ' + res.status)







          var html = await res.text()
          var doc = new DOMParser().parseFromString(html, 'text/html')
          var slides = doc.querySelectorAll('.splide__slide')
          if (slides.length > 0) {
            var htmls = []
            slides.forEach(function(s) {
              htmls.push(s.outerHTML)
            })
            splide.add(htmls)
          }

          var pag = doc.querySelector('script[data-cart-suggestions-pagination]')
          if (pag) {
            try {
              var data = JSON.parse(pag.textContent)
              el.dataset.suggestionsPage = String(data.current)
              el.dataset.suggestionsHasNext = data.hasNext
                ? 'true'
                : 'false'
            } catch (e) {
              el.dataset.suggestionsHasNext = 'false'
            }
          } else {
            el.dataset.suggestionsHasNext = 'false'
          }

// If the fetched page yielded zero usable slides but more pages exist
// (everything on this page was filtered out), keep chasing.
          if (slides.length === 0 && el.dataset.suggestionsHasNext === 'true') {
            el.dataset.suggestionsLoading = 'false'
            return loadNextPage(splide, el)
          }
        } catch (err) {
          console.error('[cart suggestions] load next page', err)
          el.dataset.suggestionsHasNext = 'false'
        } finally {
          el.dataset.suggestionsLoading = 'false'
        }
      }

// ===== Variant-picker modal =====
      var modalEl = null
      var modalState = {
        card: null,
        optionsNode: null
      }

// Lazily grab the modal and lift it onto <body> so position:fixed isn't
// trapped by the cart drawer panel's translateX transform.
      function getModal() {
        if (modalEl) 
          return modalEl







        var m = document.querySelector('[data-cart-sug-modal]')
        if (! m) 
          return null







        if (m.parentNode !== document.body) 
          document.body.appendChild(m)







        modalEl = m

// The modal lives on <body>, outside the cart drawer panel. The drawer
// closes itself on any click/Esc that lands outside its panel, so every
// modal interaction must be stopped from bubbling up to those listeners.
        m.addEventListener('click', function(e) {
          e.stopPropagation()

          if (e.target.closest('[data-cart-sug-modal-close]')) {
            closeModal()
            return
          }

          var addBtn = e.target.closest('[data-cart-sug-modal-add]')
          if (addBtn) {
            var variantId = addBtn.dataset.suggestionVariantId
            if (! variantId || addBtn.disabled || addBtn.classList.contains('is-loading')) 
              return







            addToCart(variantId, addBtn, modalState.card, true)
          }
        })
        return m
      }

      function wireVariants(optionsNode, variants, refs) {
        var inputs = optionsNode.querySelectorAll('[data-cart-suggestions-option-input]')
        var positions = []
        var inputsByPosition = {}
        inputs.forEach(function(input) {
          var pos = input.dataset.optionPosition
          if (! inputsByPosition[pos]) {
            inputsByPosition[pos] = []
            positions.push(pos)
          }
          inputsByPosition[pos].push(input)
        })
        positions.sort(function(a, b) {
          return Number(a) - Number(b)
        })

        function getCurrent() {
          return positions.map(function(pos) {
            var checked = inputsByPosition[pos].find(function(i) {
              return i.checked
            })
            return checked
              ? checked.value
              : null
          })
        }

        function update() {
          var current = getCurrent()
          var matched = variants.find(function(v) {
            for (var i = 0; i < current.length; i++) {
              if (current[i] !== null && v.options[i] !== current[i]) 
                return false







            }
            return true
          })
          if (! matched) 
            return







          if (refs.btn) {
            refs.btn.dataset.suggestionVariantId = String(matched.id)
            refs.btn.disabled = ! matched.available
            refs.btn.textContent = matched.available
              ? refs.addLabel
              : soldOutLabel()
          }
          if (refs.img && matched.featured_image) {
            refs
              .img
              .removeAttribute('srcset')
              refs
              .img
              .src = matched.featured_image
          }
          if (refs.priceEl) 
            refs.priceEl.innerHTML = matched.price







          if (refs.compareEl) {
            if (matched.compare_at_price) {
              refs.compareEl.innerHTML = matched.compare_at_price
              refs.compareEl.removeAttribute('hidden')
            } else {
              refs.compareEl.setAttribute('hidden', '')
            }
          }
        }

// The same options node is reused every time its card's modal opens,
// so attach the change listeners only once.
        if (! optionsNode.dataset.variantsWired) {
          optionsNode.dataset.variantsWired = 'true'
          inputs.forEach(function(input) {
            input.addEventListener('change', update)
          })
        }
        update()
      }

      function openModal(card) {
        var m = getModal()
        if (! m) 
          return







        var optionsNode = card.querySelector('[data-cart-suggestions-options]')
        var dataEl = card.querySelector('[data-cart-suggestions-variants]')
        if (! optionsNode || ! dataEl) 
          return







        var variants
        try {
          variants = JSON.parse(dataEl.textContent)
        } catch (err) {
          return
        }

        var nameLink = card.querySelector('[data-cart-suggestions-name]')
        var cardImg = card.querySelector('[data-cart-suggestions-image]')
        var url = nameLink
          ? nameLink.getAttribute('href')
          : '#'

        m.querySelectorAll('[data-cart-sug-modal-link]').forEach(function(a) {
          a.setAttribute('href', url)
        })
        var titleEl = m.querySelector('[data-cart-sug-modal-title]')
        if (titleEl) {
          titleEl.textContent = nameLink
            ? nameLink.textContent.trim()
            : ''
          titleEl.setAttribute('href', url)
        }

        var modalImg = m.querySelector('[data-cart-sug-modal-image]')
        if (modalImg && cardImg) {
          modalImg.removeAttribute('srcset')
          modalImg.src = cardImg.currentSrc || cardImg.src
          modalImg.alt = cardImg.alt || ''
        }

// Move the live options node in (keeps the per-value swatch <style> + ids).
        var optWrap = m.querySelector('[data-cart-sug-modal-options]')
        optWrap.innerHTML = ''
        optionsNode.removeAttribute('hidden')
        optWrap.appendChild(optionsNode)

        modalState.card = card
        modalState.optionsNode = optionsNode

        var addBtn = m
          .querySelector('[data-cart-sug-modal-add]')
          wireVariants(optionsNode, variants, {
            btn: addBtn,
            img: modalImg,
            priceEl: m.querySelector('[data-cart-sug-modal-prices] [data-cart-suggestions-price]'),
            compareEl: m.querySelector('[data-cart-sug-modal-prices] [data-cart-suggestions-compare]'),
            addLabel: addBtn
              ? (addBtn.dataset.addLabel || addBtn.textContent.trim())
              : ''
          })
          if (addBtn && ! addBtn.dataset.addLabel) 
            addBtn.dataset.addLabel = addBtn.textContent.trim()







          m
          .removeAttribute('hidden')
          m
          .offsetHeight
          m
          .classList
          .add('is-open')
      }

      function closeModal() {
        var m = getModal()
        if (! m) 
          return







        m.classList.remove('is-open')

// Return the options node to its card so the modal can be reused.
        if (modalState.card && modalState.optionsNode) {
          modalState.optionsNode.setAttribute('hidden', '')
          var cardInner = modalState.card.querySelector('.cart-suggestions__card')
          if (cardInner) 
            cardInner.appendChild(modalState.optionsNode)







        }
        modalState.card = null
        modalState.optionsNode = null

        window.setTimeout(function() {
          if (! m.classList.contains('is-open')) 
            m.setAttribute('hidden', '')







        }, 280)
      }

      function removeSlide(slideEl) {
        if (! splideInstance || ! slideEl) 
          return







        var match = splideInstance
          .Components
          .Slides
          .get()
          .find(function(s) {
            return s.slide === slideEl
          })
        if (match) 
          splideInstance.remove(match.index)







        var listEl = document.querySelector('.cart-suggestions-splide')
        if (listEl) 
          maybeLoadMore(splideInstance, listEl)







      }

      async function addToCart(variantId, btn, slideEl, fromModal) {
        btn.classList.add('is-loading')
        try {
          var res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(
              {
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                    properties: {
                      _source: 'cart_upsell',
                      _upsell_collection: 'UpSell'
                    }
                  }
                ]
              }
            )
          })
          if (! res.ok) 
            throw new Error('cart/add failed: ' + res.status)







          var data = await res.json()
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data,
              addToCartBtn: btn
            }
          }))

          if (fromModal) 
            closeModal()







          removeSlide(slideEl)
        } catch (err) {
          console.error('[cart suggestions]', err)
        } finally {
          btn.classList.remove('is-loading')
        }
      }

      function mountSlider() {
        var el = document.querySelector('.cart-suggestions-splide')
        if (! el || el.dataset.splideInit === 'true') 
          return







        if (typeof Splide === 'undefined') {
          window.addEventListener('load', mountSlider, {once: true})
          return
        }
        el.dataset.splideInit = 'true'
        splideInstance = new Splide(el, {
          type: 'slide',
          fixedWidth: '178px',
          perMove: 1,
          gap: '10px',
          arrows: true,
          pagination: false,
          padding: {
            right: '40px'
          },
          breakpoints: {
            768: {
              fixedWidth: '220px',
              gap: '8px',
              arrows: false,
              padding: {
                right: '30px'
              }
            }
          }
        })
        splideInstance.on('moved', function() {
          maybeLoadMore(splideInstance, el)
        })
        splideInstance.on('mounted', function() {
          maybeLoadMore(splideInstance, el)
        })
        splideInstance.mount()
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mountSlider, {once: true})
      } else {
        mountSlider()
      }

// Card "Add to cart": products with variants open the modal,
// single-variant products go straight to cart.
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-suggestions__add')
        if (! btn || btn.hasAttribute('data-cart-sug-modal-add')) 
          return







        var card = btn.closest('[data-cart-suggestions-card]')
        if (! card) 
          return







        if (card.querySelector('[data-cart-suggestions-options]')) {
          e.preventDefault()
          openModal(card)
          return
        }

        var variantId = btn.dataset.suggestionVariantId
        if (! variantId || btn.classList.contains('is-loading')) 
          return







        addToCart(variantId, btn, card, false)
      })

// Close the modal on Escape. Capture phase on window so it runs before
// the cart drawer's own Esc handler — when the modal is open we close it
// and stop the event so the drawer underneath stays open.
      window.addEventListener('keyup', function(e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) 
          return







        if (modalEl && modalEl.classList.contains('is-open')) {
          e.stopImmediatePropagation()
          closeModal()
        }
      }, true)
    })()
